import React, { useEffect, useState } from 'react';
import { Col, InputNumber, Row, Slider } from 'antd';
import { useSelector } from 'react-redux';

const IntegerSlider = ({ id, defaultValue, min, max, step, callback }) => {
  const treeData = useSelector((state) => state.tree.treeData);
  const [inputValue, setInputValue] = useState(defaultValue);

  useEffect(() => {
    setInputValue(defaultValue);
  }, [treeData]);

  return (
    <Row>
      <Col span={16}>
        <Slider
          step={step}
          style={{ minWidth: '90px' }}
          min={min}
          max={max}
          onChange={setInputValue}
          onAfterChange={callback}
          value={typeof inputValue === 'number' ? inputValue : 0}
        />
      </Col>
      <Col span={8}>
        <InputNumber
          id={id}
          step={step}
          min={min}
          max={max}
          style={{
            marginLeft: '25px',
            width: '60px',
          }}
          value={inputValue}
          onChange={(newValue) => {
            setInputValue(newValue);
            callback(newValue);
          }}
        />
      </Col>
    </Row>
  );
};

export default IntegerSlider;
